import loadable from '@loadable/component';

const ProductTabReviews = loadable(() =>
  import(/* webpackChunkName: "ProductTabReviews" */ './product-tab-reviews')
);

export default ProductTabReviews;
